import { render, staticRenderFns } from "./DonutChart35.vue?vue&type=template&id=21f2fcbe&scoped=true&"
import script from "./DonutChart35.vue?vue&type=script&lang=js&"
export * from "./DonutChart35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2fcbe",
  null
  
)

export default component.exports